import { HiUsers } from "react-icons/hi2";
import { useGetAllUsersQuery } from "../../../hooks/queries/useProfileQueries";
import UserManagementContainer from "../../shared/UserManagementContainer";

const useEmptyCreateUserMutation = () => null;

const UserRolesTab = () => {
  return (
    <UserManagementContainer
      title="User Management"
      icon={<HiUsers size={20} />}
      showCreateButton={false}
      useUsersQuery={useGetAllUsersQuery}
      useCreateUserMutation={useEmptyCreateUserMutation}
      searchPlaceholder="Search users..."
    />
  );
};

export default UserRolesTab;
